import Overlay from 'components/Layout/Overlay';
import {FC, useContext} from 'react';
import {twMerge} from 'tailwind-merge';
import {t} from 'ttag';

import DropdownContext from '../context';
import DrawerContent from './DrawerContent';
import DrawerOption from './DrawerOption';
import CLEAR_SELECTION from './DrawerOption/types';
import DrawerSearchField from './DrawerSearchField';

type DrawerProps = {
    className?: string;
};

const Drawer: FC<DrawerProps> = ({className}) => {
    const {
        hasClearSelection,
        isSearchable,
        onClickClearSelection,
        refDrawer,
        refField,
        selectedOptions,
    } = useContext(DropdownContext);

    return (
        <Overlay
            aria-label="dropdown-overlay"
            className={twMerge(
                'border border-blue-400 bg-dark-primary p-1 shadow-md',
                className,
            )}
            element={refField.current}
            layoutLayer="z-dropdown"
            layoutMethod="bottom-or-top"
            layoutOffset={8}
            matchWidth={true}
            role="dialog"
        >
            <div ref={refDrawer}>
                {isSearchable && <DrawerSearchField />}
                <DrawerContent />
                {hasClearSelection && selectedOptions.length > 0 && (
                    <DrawerOption
                        aria-label="clear-selection"
                        className={twMerge(
                            'text-light-secondary',
                            'hover:bg-grey-200',
                            'active:bg-grey-300',
                            'focus:bg-grey-200 focus:outline-none',
                        )}
                        isCheckable={false}
                        label={t`Clear selection`}
                        onClick={onClickClearSelection}
                        value={CLEAR_SELECTION}
                    />
                )}
            </div>
        </Overlay>
    );
};
Drawer.displayName = 'Drawer';

export default Drawer;
